import React, {FC} from 'react';
import {useSelector} from 'react-redux';

import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';
import {selectEntityData} from 'modules/data';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {showMessageFromResponse} from 'shared/utils';
import {useLazyGetAdditionalFieldsQuery} from 'store/api/form-additional-options/form-additional-options';
import {useAppDispatch} from 'store/config/hooks';
import {TAppState} from 'store/config/types';
import {openModal} from 'store/slices/modals-slice';

import {EMPTY_FIELD_MESSAGE} from './open-document-xml-modal.constants';

interface IOpenDocumentXmlModalProps extends ITableActionProps {
}

export const OpenDocumentXmlModal: FC<IOpenDocumentXmlModalProps> = ({
    meta,
    wrapper,
    entityName,
    ...props
}: IOpenDocumentXmlModalProps) => {
    const {modalName, referenceUrl} = meta;
    const {selectedRowKeys = []} = useSelector((state: TAppState) => (
        selectEntityData(entityName,
            EEntityType.TABLE)(state) || {}
    ) as ITableEntityData);

    const id = selectedRowKeys.length && selectedRowKeys[0];

    const [trigger] = useLazyGetAdditionalFieldsQuery();

    const dispatch = useAppDispatch();
    const onClick = async () => {
        try {
            if (id && referenceUrl) {
                const response = await trigger({referenceUrl, id}).unwrap();
                if (modalName && response && response.length) {
                    dispatch(openModal({
                        modalName,
                        entityName: meta?.modalEntityName || entityName,
                        parentEntityName: entityName,
                    }));
                } else if ((response && !response.length) || !response) {
                    showMessageFromResponse({response: undefined, isError: true, customMessage: EMPTY_FIELD_MESSAGE});
                }
            }
        } catch (e) {
            console.error(e);
        }
    };
    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={onClick}
            actionIcon={meta.actionIcon}
            disabled={!id}
        >
            {meta.actionTitle}
        </Component>
    );
};
